module.exports = "../static/images/9b1aa6.png";